// extracted by mini-css-extract-plugin
module.exports = {"quotes":"style_quotes__2Mnjc"};